/**
 * lib/assignmentOnly.ts
 * Whether the console shows only "My assignments" (SKTICK-DB-001 Surface A).
 *
 * An assignment-only user — a franchise outlet manager — enters no space and
 * sees only the tickets assigned to them. Zero accessible spaces used to be
 * the whole test, so a brand-new org's OWNER, whose org had no space yet,
 * landed on that view with no menu and no New ticket button (dev, 28 Oct
 * 2026). An org admin runs the workspace and is never assignment-only; the API
 * now gives a brand-new org its default space when its admin asks for spaces.
 *
 * Null while loading: showing space chrome and then taking it away would both
 * flicker and, briefly, name a space the user must not see.
 */
export function isAssignmentOnlyUser(opts: {
  loading: boolean;
  isAdmin: boolean;
  accessibleSpaceCount: number;
}): boolean | null {
  if (opts.loading) {
    return null;
  }
  if (opts.isAdmin) {
    return false;
  }
  return opts.accessibleSpaceCount === 0;
}
